<!--商品 -->
<template>
	<div class="wrap">

		<div class="header-wrap">
			<div class="header">
				<img src="../assets/return.png" class="return-img" @click="$router.back()">
				<div class="search-bar"  @click="$router.push('/product-search')">
					<img src="../assets/search-icon.png" class="search-icon">
					<input placeholder="请输入搜索关键字" class="search-input" />
				</div>
			</div>
			<ul class="tab-list">
				<li>推荐</li>
				<li class="active">全部</li>
				<div class="postion-cart-box" @click="$router.push('/product-address-shopping-cart')">
					<img src="../assets/icon-62.png" class="postion-cart">
					<span class="postion-cart-num" v-if="total_num">{{ total_num }}</span>
				</div>
			</ul>
		</div>


		<!-- 推荐 -->
		<!-- <ul class="list">
			<li  @click="$router.push('/product-details')">
				<img src="../assets/img.png" class="item-img">
				<div class="item-bottom">
					<p class="item-name">AUTOSAR 工程师</p>
					<div class="item-between">
						<p class="item-price">
							¥<span>344</span>
						</p>
						<img src="../assets/icon-61.png" class="item-cart-icon">
					</div>
				</div>
			</li>
			<li  @click="$router.push('/product-details')">
				<img src="../assets/img.png" class="item-img">
				<div class="item-bottom">
					<p class="item-name">AUTOSAR 工程师</p>
					<div class="item-between">
						<p class="item-price">
							¥<span>344</span>
						</p>
						<img src="../assets/icon-61.png" class="item-cart-icon">
					</div>
				</div>
			</li>
			<li  @click="$router.push('/product-details')">
				<img src="../assets/img.png" class="item-img">
				<div class="item-bottom">
					<p class="item-name">AUTOSAR 工程师</p>
					<div class="item-between">
						<p class="item-price">
							¥<span>344</span>
						</p>
						<img src="../assets/icon-61.png" class="item-cart-icon">
					</div>
				</div>
			</li>
			<div class="normal-box-small">
				<img src="../assets/normal.png">
				暂无数据
			</div>
		</ul> -->

		<!-- 全部 -->
		<div class="wrap2">
			<div class="leftsidebar">
				<ul class="leftsidebar-tab-list">
          <li
              v-for="(item, index) in classList"
              :key="index"
              :class="{ active: classCurrent === item.id }"
              @click="checkClass(index)"
          >
            {{ item.title }}
          </li>
				</ul>
			</div>

			<div class="rightsidebar">
				<ul class="all-list">
					<li v-for="(item, index) in classChildren" :key="index">
						<p class="list-title">{{ item.title }}</p>
						<ul class="sub-list">
							<li
                  v-for="(item2, index2) in classResultMap[`${classCurrent},${item.id}`].list"
                  :key="index2"
                  @click="$router.push(`/product-details?product_id=${item2.id}`)"
              >
								<img :src="item2.cover" class="sub-item-img">
								<div class="sub-item-sidebar">
									<p class="sub-item-name">{{ item2.name }}</p>
									<p class="sub-item-price">¥{{ item2.low_price }}-¥{{ item2.max_price }}</p>
								</div>
							</li>
              <button
                  type="button"
                  class="more-btn"
                  v-if="
                  classResultMap[`${classCurrent},${item.id}`].list.length > 0
                  &&
                  classResultMap[`${classCurrent},${item.id}`].list.length % commonParams.page_num === 0
                "
                  @click="getList([item.id])"
              >
                展开更多
                <img src="../assets/icon-7.png">
              </button>
              <normal-box :show="classResultMap[`${classCurrent},${item.id}`].list.length === 0" style="padding: 30px 0"/>
						</ul>
					</li>
					<div class="normal-box-small" v-if="classChildren.length === 0">
						<img src="../assets/normal.png">
						暂无数据
					</div>
				</ul>
			</div>
		</div>

		<div class="cart-box"  @click="$router.push('/product-address-shopping-cart')">
			<img src="../assets/cart.png">
			<span class="cart-num" v-if="total_num">{{ total_num }}</span>
		</div>

		<div class="float-box">
			<img src="../assets/icon-60.png">
		</div>

	</div>
</template>

<script>
import {MallService, RecruitService, TrolleyService} from "@/common/service";
import NormalBox from "@/components/normal-box";

  export default {
    components: {NormalBox},
    data() {
			return {
        commonParams: {
          sort_type: 1,  // 1默认2时间升序3时间降序
          page_num: 5,  // 每页数
        },
        classList: [],
        classCurrent: 0,
        classChildren: [],
        classResultMap: {},
        loading: false,

        total_num: 0,
			};
		},
    mounted() {
      this.getCateTree();
      this.getTrolleyNum();
    },
    methods: {
      getTrolleyNum() {
        TrolleyService.getTrolleyNum().then(({data}) => {
          this.total_num = data.total_num;
        });
      },
      getCateTree() {
        this.classResultMap = {};
        return MallService.getGoodsCate().then(({ data }) => {
          this.classList = data.list;
          if (data.list.length > 0) {
            this.classCurrent = data.list[0].id;
            this.classChildren = data.list[0].children;
            this.getList(this.classChildren.map(item => item.id));
          }
        });
      },
      getList(ids = []) {
        this.loading = true;
        const req = (id) => {
          const key = `${this.classCurrent},${id}`;
          if (!this.classResultMap[key]) {
            this.$set(this.classResultMap, key, { page: 1, list: [] });
          }
          const params = {
            ...this.commonParams,
            first_classify: this.classCurrent,
            second_classify: id,
            page: this.classResultMap[key].page,
          };
          return MallService.getGoodsList(params).then(({ data }) => {
            const list = data.list;
            this.classResultMap[key].list = params.page === 1 ? list : [...this.classResultMap[key].list, ...list];
            if (list.length === params.page_num) {
              this.classResultMap[key].page++;
            }
          });
        };
        if (ids.length > 0) {
          return Promise.all(ids.map(req)).finally(() => this.loading = false);
        } else {
          this.loading = false;
        }
      },
      checkClass(index) {
        if (this.loading) { return; }
        this.classCurrent = this.classList[index].id;
        this.classChildren = this.classList[index].children || [];
        this.classResultMap = {};
        this.getList(this.classChildren.map(item => item.id));
      },
      checkTab(type, isHot) {
        this.commonParams.type = type;
        this.commonParams.is_tj = isHot;
        this.classResultMap = {};
        this.getList(this.classChildren.map(item => item.id));
      },
      checkSortTab(sortType) {
        this.commonParams.sort_type = sortType;
        this.classResultMap = {};
        this.getList(this.classChildren.map(item => item.id));
      },


    },
	}
</script>

<style scoped>
	/* 头部样式 */
	.header-wrap {
		width: 100%;
		height: 84px;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 500;
		background-color: #FFFFFF;
	}

	.header {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		background-color: #FFFFFF;
		z-index: 499;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.return-img {
		width: 20px;
		margin-right: 10px;
	}

	.search-bar {
		width: calc(100% - 65px);
		height: 36px;
		background-color: #F3F3F3;
		border-radius: 100px;
		display: flex;
		align-items: center;
		padding: 0 10px;
		box-sizing: border-box;
	}

	.search-icon {
		width: 16px;
		margin-right: 10px;
	}

	.search-input {
		flex: 1;
		font-size: 15px;
	}

	.search-input::placeholder {
		color: #B6B6B6;
	}

	.tab-list {
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
		position: relative;
	}

	.postion-cart-box {
		position: absolute;
		right: 25px;
		top: 50%;
		transform: translate(0, -50%);
	}

	.postion-cart {
		width: 22px;
	}

	.postion-cart-num {
		position: absolute;
		right: -5px;
		top: -5px;
		color: #FFFFFF;
		font-size: 10px;
		height: 14px;
		line-height: 14px;
		min-width: 14px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #FF4954;
		border-radius: 50%;
		padding: 0 1px;
		box-sizing: border-box;
	}

	.tab-list>li {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 40px;
		line-height: 40px;
		font-size: 16px;
		color: #888888;
		position: relative;
	}

	.tab-list>li.active {
		font-size: 18px;
		font-weight: 500;
		color: #222222;
	}

	.tab-list>li.active::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px;
		width: 18px;
		height: 4px;
	}

	.wrap {
		width: 100%;
		height: calc(var(--vh) * 100 - 84px);
		display: flex;
		flex-direction: column;
		margin: 84px 0 0;
		box-sizing: border-box;
		background-color: #F4F4F4;
		overflow: auto;
	}

	.video-list>li {
		width: calc(50% - 7.5px);
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
		margin-bottom: 12px;
		border-radius: 10px;
		box-shadow: 0 1px 16px rgba(0, 0, 0, 0.12);
		overflow: hidden;
	}

	.video-list>li:nth-child(7n + 1) {
		width: 100%;
	}

	.float-box {
		position: fixed;
		right: 15px;
		bottom: 80px;
	}

	.float-box>img {
		width: 64px;
	}

	.cart-box {
		position: fixed;
		right: 15px;
		bottom: 143px;
	}

	.cart-box>img {
		width: 64px;
	}

	.cart-num {
		position: absolute;
		right: 7px;
		top: 10px;
		color: #FFFFFF;
		font-size: 10px;
		min-width: 14px;
		height: 14px;
		line-height: 14px;
		background-color: #FF4954;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.wrap2 {
		width: 100%;
		height: calc(100vh - 84px);
		display: flex;
		flex-direction: row;
		box-sizing: border-box;
		background-color: #F4F4F4;
		padding: 0 0 0;
		position: relative;
	}

	.list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		padding: 12px 15px;
		box-sizing: border-box;
	}

	.list>li {
		width: calc(50% - 7.5px);
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		border-radius: 12px;
		margin-bottom: 12px;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	.item-img {
		width: 100%;
		height: 130px;
	}

	.item-bottom {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 5px 10px 14px;
		box-sizing: border-box;
	}

	.item-name {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #222222;
		font-size: 15px;
		margin-bottom: 10px;
		font-weight: bold;
	}

	.item-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.item-price {
		font-size: 14px;
		color: #FF4954;
		font-weight: bold;
	}

	.item-price>span {
		font-size: 18px;
	}

	.item-cart-icon {
		width: 20px;
	}

	.normal-box-small {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 14px;
		color: #999992;
		padding: 120px 0;
	}

	.normal-box-small>img {
		width: 150px;
		margin-bottom: 9px;
	}

	.leftsidebar {
		width: 80px;
		height: 100%;
		overflow-y: auto;
	}

	.leftsidebar-tab-list {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.leftsidebar-tab-list>li {
		width: 100%;
		text-align: center;
		height: 56px;
		font-size: 14px;
		color: #222222;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.leftsidebar-tab-list>li.active {
		font-weight: 500;
	}

	.leftsidebar-tab-list>li.active::after {
		content: "";
		position: absolute;
		top: 50%;
		left: 0;
		transform: translate(0, -50%);
		background: #2A63F3;
		width: 4px;
		height: 18px;
	}

	.rightsidebar {
		width: calc(100% - 95px);
		height: 100%;
		overflow-y: auto;
	}

	.all-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding-bottom: 10px;
	}

	.all-list>li {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.list-title {
		width: 100%;
		height: 44px;
		line-height: 44px;
		display: flex;
		align-items: center;
		color: #222222;
		font-size: 14px;
		font-weight: bold;
	}

	.sub-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 14px 10px;
		box-sizing: border-box;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		border-radius: 12px;
	}

	.sub-list>li {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 14px;
	}

	.sub-list>li:last-of-type {
		margin-bottom: 0;
	}

	.sub-item-img {
		width: 70px;
		height: 70px;
		border-radius: 8px;
		margin-right: 12px;
	}

	.sub-item-sidebar {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.sub-item-name {
		width: 100%;
		color: #222222;
		font-size: 14px;
		font-weight: bold;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		margin-bottom: 8px;
	}


	.sub-item-price {
		color: #FF4954;
		font-size: 14px;
		font-weight: bold;
	}

	.more-btn {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #2A63F3;
		font-size: 12px;
		padding: 10px 0 0;
	}

	.more-btn>img {
		width: 8px;
		margin: 0 0 0 4px;
	}
</style>
